// Fanplayr Adaptor (customer-vtex) v1.10.7
// Hodor v1.6.2
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var getTagInfo = function () {
  //vtex/adaptor/adaptor.js?ak=b1ce6463c389168c634e404813d14189
  var tags = document.getElementsByTagName('script');
  var i;

  for (i = 0; i < tags.length; i++) {
    var tag = tags[i];
    if (tag.src) {
      var match = tag.src.match(/vtex\/adaptor\/adaptor\.js\?ak=[^&]+(?:&px=(?:[^&]+))?(?:&ep=([^&]+))?(?:&sd=([^&]+))?/i);
      if (match) {
        return {
          endpoint: match[1],
          baseDomain: match.length > 1 ? match[2] : ''
        };
      }
    }
  }

  return null;
};

try {
  var tagInfo = getTagInfo();

  if (tagInfo) {
    window.fanplayr_api = window.fanplayr_api || [];
    window.fanplayr_api.push({
      _type: 'platform.config',
      connect: {
        endpoint: tagInfo.endpoint,
        baseDomain: tagInfo.baseDomain
      }
    });
  }
} catch (error) {}

},{}],2:[function(require,module,exports){
var adaptor = require('__hodor/adaptor.js');
var platform = require('__hodor/platform.js');
var utils2 = require("./utils");
var state = require('__hodor/state.js');
var capabilities = require('__hodor/capabilities.js');
var stash = require('__hodor/stash.js');

var log = adaptor.log;

stash.load();

var loadDiscountCode = function () {
  state.cart.discountCode = stash.get('discountCode');
};

var setDiscountCode = function () {
  if (state.page.type === 'cart') {
    var coupon = utils2.getVal('window.vtexjs.checkout.orderForm.marketingData.coupon');
    state.cart.discountCode = coupon;
    stash.set('discountCode', state.cart.discountCode, 'sk');
    stash.save();
  } else {
    loadDiscountCode();
  }
};

var setCartDetails = function () {
  if (utils2.getVal('window.vtexjs.checkout.orderForm.items')) {

    //log('setCartDetails');

    var orderForm = window.vtexjs.checkout.orderForm;
    var items = orderForm.items;

    var cart = state.cart;
    cart.clear();

    var numItems = 0;
    var lineItemCount = 0;
    var subTotal = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      var p = {};
      p.id = item.productId;
      p.name = item.name;
      p.price = item.price / 100;
      p.sku = item.id;
      p.url = window.location.protocol + '//' + window.location.hostname + item.detailUrl; // needs hostname
      var imageRegex = /\/ids\/\d+-(\d+-\d+)\//;
      if (imageRegex.test(item.imageUrl)) {
        p.image = item.imageUrl.replace(/-\d+-\d+\//, "-360-180/");
      } else {
        p.image = item.imageUrl;
      }
      p.quantity = item.quantity;

      p.data = {};
      p.data.brandId = item.additionalInfo.brandId;
      p.data.brandName = item.additionalInfo.brandName;

      if (p.data.brandName) {
        p.brands = [p.data.brandName];
      }

      lineItemCount++;
      numItems += p.quantity;
      subTotal += p.quantity * p.price;

      var cartProd = cart.products.add(p);

      for (var c in item.productCategories) {
        cartProd.categories.add(c, item.productCategories[c]);
      }
    }

    var totalizers = orderForm.totalizers;
    if (totalizers && totalizers.length) {
      var discount = 0;
      for (var j = 0; j < totalizers.length; j++) {
        if (totalizers[j].id === 'Discounts') {
          discount = Math.abs(totalizers[j].value) / 100;
        }
      }
      cart.discount = discount;
    }

    setDiscountCode();

    cart.updateTotals();
  } else {
    return null;
  }
};

adaptor.on("ready", function (fanplayr, $, _) {
  // Do some scraping!
  var tagInfo = utils2.getTagInfo();

  if (!tagInfo) {
    return;
  }

  platform.config.accountKey = tagInfo.accountKey;

  var allowedCoupons = stash.get('allowedCoupons') || [];
  if (!$.isArray(allowedCoupons)) {
    allowedCoupons = [];
  } else {
    for (var j = 0; j < allowedCoupons.length; j++) {
      if (allowedCoupons[j]) {
        allowedCoupons[j] = allowedCoupons[j].toLowerCase();
      }
    }
  }

  for (var i = 0; i < allowedCoupons.length; i++) {
    allowedCoupons[i] = allowedCoupons[i].toLowerCase();
  }

  if (window.location.pathname.indexOf('/checkout/orderPlaced/') === 0) {
    state.page.type = 'order';
  } else {
    utils2.waitForExistance(function () {
      return utils2.getVal('window.vtexjs.checkout');
    }, function () {

      var API = window.vtexjs.checkout;

      state.page.type = 'page';
      if (window.helper && window.helper.eventType) {
        switch (window.helper.eventType) {
          case 'homeView':
            state.page.type = 'home';
            break;
          case 'departmentView':
          case 'categoryView':
            state.page.type = 'cat';
            break;
          case 'productView':
            state.page.type = 'prod';
            break;
        }
      }

      if (window.location.pathname.indexOf('/checkout') === 0) {
        state.page.type = 'cart';
      }

      if (state.page.type === 'prod') {

        var skuJson = window.skuJson;

        state.page.product.id = skuJson.productId;
        //state.page.product.sku = '';
        state.page.product.name = skuJson.name;
        state.page.product.price = skuJson.skus[0].bestPrice / 100;
        state.page.product.image = skuJson.skus[0].image;
        state.page.product.url = window.location.href;
      }

      if (state.page.type === 'cat' || state.page.type === 'prod') {
        if (window.vtxctx) {
          state.page.categories.add(window.vtxctx.categoryId, window.vtxctx.categoryName);
          state.page.categories.add(window.vtxctx.departmentyId, window.vtxctx.departmentName);
          if (state.page.type === 'prod') {
            state.page.product.categories.add(window.vtxctx.categoryId, window.vtxctx.categoryName);
            state.page.product.categories.add(window.vtxctx.departmentyId, window.vtxctx.departmentName);
          }
        }
      }
      capabilities.sessionOffer = function (event) {
        var code = event.code;

        if (allowedCoupons.indexOf(code) === -1) {
          allowedCoupons.push(code.toLowerCase());
        }
        stash.set("allowedCoupons", allowedCoupons, "sk");
        stash.save();

        return true;
      };

      capabilities.applyToCart = function (event) {

        var couponCode = event.code;
        var prefix = tagInfo.prefix;

        // disallow prefix
        if (prefix && couponCode.toLowerCase().indexOf(prefix.toLowerCase()) === 0) {
          if (allowedCoupons.indexOf(couponCode.toLowerCase()) === -1) {
            couponCode = ' ';
          }
        }

        if (state.page.type === 'cart') {
          // apply directly
          API.addDiscountCoupon(couponCode);
        } else {

          API.getOrderForm().then(function () {
            API.addDiscountCoupon(couponCode).then(function () {
              window.location = 'https://' + window.location.hostname + "/checkout/";
            });
          });
        }
      };

      // if we're at the cart let's override the coupon stuff
      if (state.page.type === 'cart') {
        API._addDiscountCoupon = API.addDiscountCoupon;
        API.addDiscountCoupon = function (couponCode, expectedOrderFormSections) {

          var prefix = tagInfo.prefix;
          if (prefix && couponCode.toLowerCase().indexOf(prefix.toLowerCase()) === 0) {
            if (allowedCoupons.indexOf(couponCode.toLowerCase()) === -1) {
              couponCode = '_____' + couponCode;
            }
          }

          return API._addDiscountCoupon.apply(API, [couponCode, expectedOrderFormSections]);
        };

        window.setTimeout(function () {
          var discountCode = stash.get("fpAtcCode");
          if (discountCode) {
            stash.del("fpAtcCode");
            stash.save();
            capabilities.applyToCart({ code: discountCode });
          }
        }, 2000);
      }

      var doCartAndTracking = function () {
        setCartDetails();

        // if the cart changes at any time we also want to re-track
        utils2.watchForChange(function () {
          return utils2.getVal('window.vtexjs.checkout.orderForm.value');
        }, function (newCartValue) {
          setCartDetails();
          //log(state);
          //log('TRACKING', state);
          trackPage();
        });

        // yay, let's track the page ...
        trackPage();
      };

      if (utils2.getVal('window.vtexjs.checkout.orderForm')) {
        doCartAndTracking();
      } else {
        // we use "always" instead of "done" because we want tracking to happen even if we can't
        // get the cart details
        window.vtexjs.checkout.getOrderForm().always(function (orderForm) {
          doCartAndTracking();
        });
      }
      //log('FIRST TRACK');
    });
  }

  if (state.page.type === 'order') {

    // wait for dataLayer to appear ...
    var orderWaitForVarsInterval;
    var retry = 0;
    orderWaitForVarsInterval = setInterval(function () {
      var order = state.order;
      if (window.dataLayer) {
        for (var i = 0; i < window.dataLayer.length; i++) {
          if (window.dataLayer[i].transactionId) {

            clearInterval(orderWaitForVarsInterval);

            var dl = window.dataLayer[i];

            var user = state.user;

            order.id = dl.transactionId;
            order.number = dl.transactionId;

            order.currency = dl.transactionCurrency;
            order.shipping = dl.transactionShipping;
            order.tax = dl.transactionTax;

            order.discountCode = dl.coupon;

            order.gross = 0;

            for (var j = 0; j < dl.transactionProducts.length; j++) {

              var p = dl.transactionProducts[j];

              order.gross += p.originalPrice * p.quantity;

              order.products.add({
                id: p.id,
                name: p.name,
                price: p.originalPrice,
                quantity: p.quantity
              });
            }

            order.discount = order.gross + order.shipping - order.tax - dl.transactionTotal;

            //user.firstName;
            //user.lastName;
            //user.email;
            //order.email;

            trackOrder();
          }
        }
      } else if (retry > 20) {
        clearInterval(orderWaitForVarsInterval);
        order.cartAction = 'repeat';
        try {
          order.id = order.number = /\?og=(\d+)/.exec(window.location.href)[1] + '-nga';
        } catch (error) {
          order.id = order.number = 'dummy-' + Math.floor(Date.now() / 1000);
        }
        trackOrder();
      }
      retry++;
    }, 250);

    // don't need normal tracking!
    return;
  }
});

var disabledAccountKeys = ['735946b5c1a259b4b6901eeec198f151', '93fd9741c4d6951b3de548d6fb8794d3'];

function trackPage() {
  if (!disabledAccountKeys.includes(platform.config.accountKey)) {
    platform.trackPage();
  }
}

function trackOrder() {
  if (!disabledAccountKeys.includes(platform.config.accountKey)) {
    platform.trackOrder();
  }
}

},{"./utils":3,"__hodor/adaptor.js":4,"__hodor/capabilities.js":5,"__hodor/platform.js":10,"__hodor/stash.js":11,"__hodor/state.js":12}],3:[function(require,module,exports){
var getTagInfo = function () {
  //vtex/adaptor/adaptor.js?ak=b1ce6463c389168c634e404813d14189
  var tags = document.getElementsByTagName('script');
  var i;

  for (i = 0; i < tags.length; i++) {
    var tag = tags[i];
    if (tag.src) {
      var match = tag.src.match(/vtex\/adaptor\/adaptor\.js\?ak=([^&]+)(&px=([^&]+))?/i);
      if (match) {
        return {
          accountKey: match[1],
          prefix: match[3] || ''
        };
      }
    }
  }

  return null;
};

var watchForChange = function (fn, cb, delay, clear) {
  if (delay === undefined) {
    delay = 250;
  }
  if (clear === undefined) {
    clear = false;
  }
  var oldValue = fn();
  var interval = setInterval(function () {
    var currentValue = fn();
    if (oldValue !== currentValue) {
      if (clear) {
        clearInterval(interval);
      }
      oldValue = currentValue;
      cb(currentValue);
    }
  }, delay);
};

var waitForExistance = function (fn, cb, delay) {
  if (delay === undefined) {
    delay = 250;
  }
  var interval = setInterval(function () {
    var currentValue = fn();
    if (currentValue) {
      clearInterval(interval);
      cb(currentValue);
    }
  }, delay);
};

var getVal = function (path) {
  var v = path.split('.');
  var obj = v.shift();
  obj = obj === 'window' ? window : window[obj];

  for (var i = 0; i < v.length; i++) {
    if (!obj || !obj.hasOwnProperty(v[i])) {
      return null;
    }
    obj = obj[v[i]];
  }
  return obj;
};

module.exports = {
  getTagInfo: getTagInfo,
  watchForChange: watchForChange,
  waitForExistance: waitForExistance,
  getVal: getVal
};

},{}],4:[function(require,module,exports){
"use strict";

var Emitter = require("./emitter");

// `adaptor` is declared at the top of the IIFE during the build process.
var adaptor = module.exports = {};

var fanplayr = window.fanplayr = window.fanplayr || {};
adaptor.api = window.fanplayr_api = window.fanplayr_api || [];

Emitter.mixin(adaptor);

var log = adaptor.log = require("./log");
var config = adaptor.config = require("./config");
var _ = adaptor.utils = require("./utils");

adaptor.isInFrame = function () {
  var result = true;
  try {
    var w = window;
    result = w.top === w || w.top === w.self || !w.frameElement;
  } catch (ex) {}
  return !result;
};

var isCollector = config.collector;

if (config.version) {
  adaptor.version = config.version;
}

var didInit;
function init(fanplayr) {
  if (!didInit) {
    didInit = true;

    if (config.accountKey) {
      fanplayr.platform.config.accountKey = config.accountKey;
    }

    var platformUtils = fanplayr.require("platform/utils");
    for (var key in platformUtils) {
      _[key] = platformUtils[key];
    }

    adaptor.createStash = fanplayr.require("platform/stash").create;

    var stash = adaptor.stash = adaptor.createStash(_.merge({
      name: "adaptor",
      scope: "domain"
    }, config.stash || {}));

    adaptor.fanplayr = fanplayr;
    adaptor.$ = fanplayr.$;
    adaptor._ = _;

    stash.load(function () {
      var entry = require('__project/main.js');

      fanplayr.adaptor = _.merge({}, adaptor, entry || {});

      adaptor.emit("ready", fanplayr, fanplayr.$, _);
    });
  }
}

var isInFrame = adaptor.isInFrame();
if (!isInFrame || fanplayr.allowInFrame || config.allowInFrame) {
  // Prevent adaptor from loading multiple times.
  if (!fanplayr.adaptor || isCollector) {
    fanplayr.adaptor = adaptor;

    var initPlatform = function initPlatform() {
      // Boot fanplayr.
      require("./fanplayr-init")(init, adaptor.environment, config);
    };

    var bootFn = require('__project/boot.js');
    if (typeof bootFn === "function") {
      bootFn(initPlatform);
    } else {
      // Give implementing adaptor a chance to modify `adaptor.environment`.
      setTimeout(initPlatform, 0);
    }
  } else {
    log("Adaptor already loaded. Skip.");
    var reloadFn = fanplayr.adaptor && fanplayr.adaptor.onReload;
    if (typeof reloadFn === "function") {
      reloadFn();
    }
  }
} else {
  log("Adaptor prevent loading in frame: " + (window.frameElement && window.frameElement.src));
}

},{"./config":6,"./emitter":7,"./fanplayr-init":8,"./log":9,"./utils":13,"__project/boot.js":1,"__project/main.js":2}],5:[function(require,module,exports){
"use strict";

module.exports = require("./adaptor").fanplayr.platform.capabilities;

},{"./adaptor":4}],6:[function(require,module,exports){
"use strict";

// Magically replaced, do not edit.
module.exports = {
  "type": "adaptor",
  "name": "customer-vtex",
  "version": "1.10.7",
  "accountKey": "",
  "adaptorVersion": 1
};

},{}],7:[function(require,module,exports){
"use strict";

function Emitter() {
  this.events = {};

  // Last emitted values.
  this.emitCache = {};
}

var arraySlice = Array.prototype.slice;

Emitter.mixin = function (obj) {
  var emitter = new Emitter();

  obj.on = function () {
    return emitter.on.apply(emitter, arraySlice.call(arguments));
  };

  obj.emit = function () {
    return emitter.emit.apply(emitter, arraySlice.call(arguments));
  };

  obj.$emitter = emitter;

  return obj;
};

Emitter.prototype = {
  on: function on(eventType, options, cb) {
    var self = this;

    if (typeof options === "function") {
      var temp = cb;
      cb = options;
      options = temp;
    }

    if (!options) {
      options = {};
    }

    var listeners = self.events[eventType];
    if (!listeners) {
      listeners = self.events[eventType] = [];
    }

    var listener = {
      options: options,
      cb: cb
    };

    if (options.init) {
      var cached = self.emitCache[eventType];
      if (cached) {
        self.invoke(listener, cached);
      }
    }

    listeners.push(listener);
  },

  emit: function emit(eventType) {
    var self = this;

    var args = arraySlice.call(arguments, 1);
    self.emitCache[eventType] = args;

    var listeners = self.events[eventType];
    if (listeners) {
      for (var i = 0, len = listeners.length; i < len; i++) {
        self.invoke(listeners[i], args);
      }
    }
  },

  invoke: function invoke(listener, args) {
    listener.cb.apply(listener.options.context || listener.cb, args);
  }
};

module.exports = Emitter;

},{}],8:[function(require,module,exports){
"use strict";

var log = require("./log");

module.exports = function (initFn, environment, config) {
  (function (window, document) {
    var fanplayr = window.fanplayr;
    var fanplayrReady = "fanplayr_ready";

    /*
      fanplayr._loadState
        falsy: not initalized
        1: loading
        2: ready
    */

    if (fanplayr) {
      var loadState = fanplayr._loadState;

      if (loadState === 2) {
        // Already loaded.
        initFn(fanplayr);
      }

      var origFn = window[fanplayrReady];
      window[fanplayrReady] = function (f, p) {
        if (origFn) {
          origFn(f, p);
        }
        initFn(f);
      };

      if (!loadState) {
        // Fanplayr hasn't begun loading, so load it.
        var script = document.createElement("script");
        script.async = true;
        script.src = "//cdn.fanplayr.com/client/" + (environment || "production") + "/loader.js";
        var first = document.getElementsByTagName("script")[0];
        var mode = config.injectMode || 'beforeFirstScript';
        if (first && mode === 'beforeFirstScript') {
          first.parentNode.insertBefore(script, first);
        } else if (document.head && mode === 'head') {
          document.head.appendChild(script);
        } else if (document.body) {
          document.body.appendChild(script);
        }
      }
    }
  })(window, document);
};

},{"./log":9}],9:[function(require,module,exports){
"use strict";

var console, logFn;

try {
  console = window.console || window.top.console;
  logFn = console && console.log;
} catch (e) {}

var noop = function noop() {};

function create(name) {
  var log = noop;
  if (logFn) {
    if (typeof logFn.bind === "function") {
      log = logFn.bind(console, "[" + name + "]");
    } else {
      log = function log() {
        var args = Array.prototype.slice.call(arguments);
        args.unshift("[" + name + "]");
        logFn(args.join(""));
      };
    }
  }

  log.create = create;
  log.info = log;
  log.error = log;

  return log;
}

module.exports = create("adaptor");

},{}],10:[function(require,module,exports){
"use strict";

module.exports = require("./adaptor").fanplayr.platform;

},{"./adaptor":4}],11:[function(require,module,exports){
"use strict";

module.exports = require("./adaptor").stash;

},{"./adaptor":4}],12:[function(require,module,exports){
"use strict";

module.exports = require("./adaptor").fanplayr.platform.state;

},{"./adaptor":4}],13:[function(require,module,exports){
"use strict";

// modules.exports = require("./req")("platform/utils");

var _ = module.exports = {};
var log = require("./log");

_.parseInt = function (text, defaultValue) {
  var value = _parseFloat(text, defaultValue);
  if (typeof value === "number") {
    return Math.floor(value);
  }
  return value;
};

/*
  Extracts the first matched float from a string.

  @param string text       The input string.
  @param * defaultValue    The default value to return if parsing fails.
  @param string chars      Special characters.

  About `chars`:
    - Must include at least two characters.
    - The first character must be the thousands separator.
    - The second character must be the decimal character.
    - Any other characters will be matched as part of the number, but stripped before converting to a float.
*/
_.parseFloat = _parseFloat;
function _parseFloat(text, defaultValue, chars) {
  // Get defaults.
  if (typeof defaultValue === "undefined") {
    defaultValue = _parseFloat.defaultValue;
  }
  chars = chars || _parseFloat.chars;

  text = String(text);
  var value = defaultValue;
  if (text) {
    // Find the first occurance of a group of numbers and special characters. Must match:
    // - Optional negative character `-`
    // - Optional single special character
    // - One or more digits
    // - Zero or more digits and special characters
    var pattern = new RegExp("(-?[" + chars.substr(0, 2) + "]?\\d+[0-9" + chars + "]*)");
    var match = text.match(pattern);
    if (match) {
      // Build a regular expression of bad characters to strip out.
      // The first char is the separator.
      var badChars = chars.charAt(0);
      if (chars.length > 2) {
        // Add any others.
        badChars += chars.substr(2);
      }
      pattern = new RegExp("[" + badChars + "]", "g");

      // Strip bad characters.
      text = match[1].replace(pattern, "");

      // Replace the decimal character with an actual period
      // and parse as float.
      value = parseFloat(text.replace(chars.charAt(1), "."));

      if (isNaN(value)) {
        return defaultValue;
      }
    }
  }
  return value;
};

_parseFloat.defaultValue = 0;
_parseFloat.chars = ",.";

var decodeHtmlEl;
_.decodeHtml = function (value) {
  if (value) {
    if (!decodeHtmlEl) {
      decodeHtmlEl = document.createElement("div");
    }
    decodeHtmlEl.innerHTML = value;
    return decodeHtmlEl.firstChild.nodeValue;
  }
  return value;
};

_.waitUntil = function (evaluate, intervalMs, callback) {
  if (arguments.length === 2) {
    callback = intervalMs;
    intervalMs = 500;
  }

  if (typeof evaluate === "string") {
    var evalPath = evaluate;
    evaluate = function evaluate() {
      return eval(evalPath);
    };
  }

  var iterator = function iterator() {
    var value = evaluate();
    if (value) {
      callback(value);
    } else {
      setTimeout(iterator, intervalMs);
    }
  };

  iterator();
};

},{"./log":9}]},{},[4]);